import React, { FC, useState } from "react";
import { FormModal } from "../Modal";
import { HorizontalStack, VerticalStack } from "../../Stack";
import { Stack, Text } from "@fluentui/react";
import Popup from "../../Popup/Popup";
import { t } from "i18next";
import { Trans } from "react-i18next";
import { useAppDispatch } from "../../../hooks/hooks";
import { setDeleteProject } from "../../../modules/redux/ProjectDeleteSlice";
import Loader from "../../Loader";
import { useNavigate } from "react-router-dom";
import { getPrecedentDocuments } from "../../../modules/redux/Documents/document";
import ErrorIcon from "../../../assets/Icons/svg/errorIcon";
import SuccessIcon from "../../../assets/Icons/svg/successIcon";
import DeleteIcon from "../../../assets/Icons/svg/deleteIcon";
import {
  deleteProject,
  getAllProjects,
} from "../../../modules/redux/Projects/project";

const DeleteProjectModal: FC<any> = (props) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [modal, setModal] = useState<boolean>(false);
  const [upload, setUpload] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");

  const handleDeleteClick = () => {
    if (props?.projectId) {
      setModal(true);
      dispatch(deleteProject(props?.projectId)).then((res: any) => {
        if (res.meta.requestStatus === "fulfilled") {
          setTimeout(() => {
            navigate("/home")
            dispatch(setDeleteProject(props.projectName));
            dispatch(
              getPrecedentDocuments({
                limit: 21,
                offset: 0,
              })
            );
            dispatch(getAllProjects({
              limit: 30,
              offset: 0,
            }));
          }, 2000);
        }
      });
    }
  };

  function disable() {
    setModal(false);
    props.hideModal();
  }

  const icon = !upload ? <DeleteIcon /> : message === "Success" ? <SuccessIcon /> : <ErrorIcon />;

    const customContent = (
    <VerticalStack
      className="deleteContainer"
      style={{ minHeight: !modal ? "277px" : "100px" }}
    >
      {modal ? (
        <>
          <VerticalStack
            style={{
              alignItems: upload ? "" : "center",
              justifyContent: upload ? "" : "space-between",
              backgroundColor: "",
              gap: "20px",
              padding: "20px 25px",
              width: "100%",
            }}
          >
            {!upload ? <Loader /> : null}
            <Text
              style={{
                fontSize: "17px",
              }}
              className="deleteContentText"
            >
              {upload ? (
                <Text className="deleteContentText">
                  {`${props?.documentName}`} {t("deleted")}
                </Text>
              ) : (
                <Text className="deleteContentText">
                  {t("deleting")} {`${props?.documentName}`}
                </Text>
              )}
            </Text>
          </VerticalStack>
        </>
      ) : (
        <>
          <VerticalStack style={{ padding: "20px 25px", gap: "10px", background: "white", borderRadius: "8px 8px 0 0" }}>
            <div className="popup-content-icon" style={{margin: "0"}}>{icon}</div>
            <Text className="deleteContentText">
              {t("delete_conf")}&nbsp;<b>{props?.projectName}</b>?
            </Text>
            <p className="deleteContentText1">
              <Trans i18nKey="delete_proj_warning" />
            </p>
          </VerticalStack>
          <Stack className="horizontalLine"></Stack>
          <HorizontalStack
            className="deleteBottom"
            style={{ padding: "15px 25px",
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              background: "white",
              borderRadius: "0 0 8px 8px" }}
          >
            <Text className="deleteCancelButton" onClick={props.hideModal}>
            {t("cancel")}
            </Text>
            <Text className="deleteButton" onClick={handleDeleteClick}>
            {t("delete")}
            </Text>
          </HorizontalStack>
        </>
      )}
    </VerticalStack>
  );

  return (
    <Popup
      isOpen={props.isModalOpen}
      title={
        upload
          ? message === "Success"
            ? t("success")
            : t("error")
          : t("delete_project")
      }
      iconName={null}
      contentTitle={upload ? t("success") : t("error")}
      content={upload ? t("success") : t("error")}
      onClose={modal ? disable : props.hideModal}
      customContent={customContent}
      showCloseButton={!modal}
      width="480px"
      minHeight={modal ? "100px" : "277px"}
      backgroundColor={
        upload && message === "Success"
          ? "linear-gradient(90deg, #ECF0F9 0%, #EFECF9 100%)"
          : "#FCF0ED"
      }
    />
  );
};

export default DeleteProjectModal;
